import moment from 'moment'
import { InstructorSearchResultInfo } from '@interfaces/Instructor'
import { DATE_FORMAT } from '@utils/constants'
import LogoGenerator from '@utils/logo-generator'

class PortalInstructorProfile {
  profile?: InstructorSearchResultInfo

  constructor(instructor?: InstructorSearchResultInfo) {
    this.profile = instructor
  }

  get InstructorId() {
    return this.profile?.InstructorId
  }

  get Name() {
    return this.profile?.Name || ''
  }

  get IsPreferred() {
    return this.profile?.IsPreferred
  }

  get Languages() {
    return this.profile?.SpokenLanguages?.split(';') || []
  }

  get PrimaryLanguage() {
    return this.Languages[0]
  }

  get OtherLanguages() {
    return [...this.Languages].splice(1, this.Languages.length).join(', ')
  }

  get TeachingSince() {
    return this.profile?.StartDateWithBerlitz ? moment(this.profile?.StartDateWithBerlitz).format(DATE_FORMAT.MY) : ''
  }

  get Description() {
    return this.profile?.Description
  }

  get Lessons() {
    return this.profile?.TenureWorkExperience || 0
  }

  get AverageRating() {
    return (this.profile?.Rating || 0) / 2
  }

  get Avatar() {
    return LogoGenerator.getLogoDataUrl({ text: this.profile?.Name ?? '', pattern: 'space-invaders' })
  }
}

export default PortalInstructorProfile
